import React from 'react';

const AdoptionForm = () => {
  return (
    <div className='text-center flex justify-center'>
      <iframe src="https://docs.google.com/forms/d/e/1FAIpQLSdaJIKohvlTH0puiv8QaN6ADrBYryP9ifObti9AiXO6csM9fw/viewform?embedded=true" width="640" height="8769" frameborder="0" marginheight="0" marginwidth="0">Loading…</iframe>
    </div>
  );
};

export default AdoptionForm;
